import { API_MIPE } from '@/config';

export default class ClockService {
  getEpochTime() {
    return fetch(
      `${API_MIPE.BASE_URL}/api/account/servertime`
    ).then((response) => response.json());
  }
}
